function customFlagsInit() {
    createFlag($('.p-detail'))
}

function createProductSaleFlags(products) {
    products.each(function () {
        const prices = $(this).find('.prices')
        const sale = prices.find('.price-save')
        let flags = $(this).find('.flags')
        if (sale.length > 0) {
            if (flags.find('.flag.flag-sale').length === 0) {
                flags.prepend(flagSale(sale.text().replace(/[()]/g, '')))
            }

            prices.addClass('has-sale')
        }
    });
}

function createFlag(element) {
    let sale = element.find('.price-save');

    if (sale.length > 0 && sale.find('span').length > 0) {
        sale = sale.find('span');
        sale.each(function () {
            if (!$(this).hasClass('noDisplay')) {
                sale = $(this)
            }
        });
    }

    let flags = element.find('.flags');

    if (sale.length > 0) {
        if (flags.find('.flag.flag-sale').length === 0) {
            flags.prepend(flagSale(sale.text().replace(/[()]/g, '')));
        }

        sale.addClass('has-sale');
    }
}

function extractPercentage(text) {
    const match = text.match(/–\d+\s?%/); // Hledá záporné procento
    return match ? match[0] : null; // Vrací nalezené číslo nebo null, pokud nic nenajde
}
